/**
 * Appointment share cards in chat — metadata build + type guard
 * (taskChatShare.js shape; PLAN §3.4, owner Decision 5).
 *
 * Unlike workspace/collection shares this card mints NO share-link token —
 * access is the invitation row, and `chat.ex`'s unsend sweep
 * (delete_share_for_message) finds no metadata.token to clean, by design.
 * Unlike the task card it DOES carry plaintext display fields: title,
 * start/end, all_day, location — Decision 5 accepted that for v1 (metadata is
 * plaintext jsonb, the same trade the existing share cards make with
 * label/workspace_name). `description` is deliberately NEVER included.
 */

export const APPOINTMENT_SHARE_TYPE = 'appointment';

/**
 * Chat message metadata for a shared appointment. Timed events carry ISO UTC
 * instants; all-day events carry bare YYYY-MM-DD keys (the event record's own
 * §3.2 convention rides through).
 */
export function buildAppointmentShareMetadata({ event, organizerId }) {
  if (!event?.uid || organizerId == null) return null;
  return {
    v: 1,
    share_type: APPOINTMENT_SHARE_TYPE,
    appointment_uid: String(event.uid),
    organizer_id: String(organizerId),
    title: event.title || '',
    start: event.all_day ? event.start_date : event.start,
    end: event.all_day ? event.end_date : event.end,
    all_day: event.all_day === true,
    location: event.location || '',
    // NO token, NO description — see the header.
  };
}

/** Is this an appointment share card? */
export function isAppointmentShare(metadata) {
  return metadata?.share_type === APPOINTMENT_SHARE_TYPE;
}
